module.exports = __webpack_public_path__ + "media/images/icons/play_circle-67eba9d922c098d73555daf4fe55574b.svg";